import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ArrowLongRightSvg from '@/assets/ArrowLongRight.svg';

const ArrowLongRight = ({ size, variant, className }: IconProps) => (
  <img
    src={ArrowLongRightSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ArrowLongRight;
